var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"email-validation d-flex justify-center align-center"},[_c('div',{staticClass:"message d-flex justify-center align-center"},[(_vm.info.message)?_c('p',{class:`${_vm.info.color}--text`},[_vm._v(" "+_vm._s(_vm.info.message)+" ")]):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }